import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { SelectBox, Text } from "sunrise-ui";
import DiscardedAndRepairInventoryTableComponent from "../../components/tableComponents/DiscardedAndRepairInventoryTableComponent";
import TableHeading from "../../components/tableComponents/TableHeadings";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import {
  discardedInventory,
  tableTitle,
} from "../../constants/inventoryTableHeadings";
import {
  getDiscaredInventoryItemsData,
  // setDiscardedInventoryItems,
} from "../../redux/reducers/inventorySlice";

import { getAllProjectData } from "../../redux/reducers/projectReducers";
import { AppDispatch } from "../../redux/store";
import { compareDates } from "../../utilities/getDateUtils";
import Loader from "../../utilities/Loader";
import SelectOptionMsg from "../../utilities/SelectOptionMsg";
import toaster from "../../utilities/toaster";

const DiscardedInventory = () => {
  const dispatch = useDispatch<AppDispatch>();

  // -----------loader state------------
  let [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    dispatch(getAllProjectData({ endPoint: "project/get-all-projects" }));
  }, [dispatch]);
  const allProjectData = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );
  const discardedData = useSelector(
    (state: any) => state.INVENTORY.discardedInventoryItemsData
  );
  const projectsData: [] =
    allProjectData &&
    allProjectData?.map((item: any) => {
      return item?.projectName;
    });

  //filter date
  const [filterDate, setfilterDate] = useState<any>({
    from: new Date(),
    to: new Date(),
  });

  // add threshold values data
  const [projectId, setProjectId] = useState("");
  const [projectName, setProjectName] = useState<any>("");

  const profileData = useSelector((state: any) => state.PROFILE);
  const { profileDetails } = profileData;
  const { data } = profileDetails;

  useEffect(() => {
    setLoading(true);
    dispatch(
      getDiscaredInventoryItemsData({
        endPoint: `inventory/discarded-inventory?id=${projectId}`,
      })
    ).then(() => setLoading(false));
  }, [dispatch, projectId]);
  //search
  const [search, setSearch] = useState("");

  useEffect(()=>{
    setRows(discardedData);
  },[discardedData]);

  // filter by date function
  const handleFilterDate = () => {
    const data = { ...filterDate };
    const filterTable =
      discardedData && discardedData.length > 0
        ? discardedData.filter(
            (item: any) =>
              compareDates(item.item.returnedOn.split("T")[0], data) && item
          )
        : [];

    // dispatch(setDiscardedInventoryItems(filterTable));
    setRows(filterTable);
  };
  const changeReset = () => {};

  const filterData = (e: any) => {
    if (e.target.value !== "") {
      setSearch(e.target.value);

      const filterTable =
        discardedData && discardedData.length > 0
          ? discardedData.filter((item: any) =>
              item?.name?.toLowerCase()?.includes(e.target.value?.toLowerCase())
            )
          : [];

      // dispatch(setDiscardedInventoryItems(filterTable));
    setRows(filterTable);

    } else {
    setRows(discardedData);
      setSearch("");
      setLoading(true);
      dispatch(
        getDiscaredInventoryItemsData({
          endPoint: `inventory/discarded-inventory?id=${projectId}`,
        })
      ).then(() => setLoading(false));
    }
  };
  const resetSearch = () => {
    setRows(discardedData);
    setSearch("");
    setLoading(true);
    dispatch(
      getDiscaredInventoryItemsData({
        endPoint: `inventory/discarded-inventory?id=${projectId}`,
      })
    ).then(() => setLoading(false));
  };
  const handleDownload = () => {
    if (discardedData && discardedData.length === 0) {
      toaster("error", "No data available");
      return;
    }
    let a: any = document.createElement("a");
    a.target = "_blank";
    a.href = `${process.env.REACT_APP_PRO_URL}/general/download?resource=INVENTORY&subResource=DISCARD&project=${projectId}&role=admin&user=${data._id}`;
    a.click();
  };
  return (
    <>
      <Grid container className="bg--white box--shadow p1 mt1">
        <Grid item xs={12}>
          <Grid container className="d-flex v-center table_heading_box">
            <Grid container className="mt1 mb1">
              <Grid item xs={4}>
                <Grid className="mr-1">
                  <Text
                    type="normal"
                    fonts="normal"
                    fontSize={16}
                    className="mb0 mt0"
                  >
                    <span className="fw500">Select Project*</span>
                  </Text>
                  <SelectBox
                    data={projectsData ? projectsData : DATA_NOT_FOUND}
                    placeHolder="Select Project"
                    defaultVal={projectName}
                    resetVal={projectName ? false : true}
                    changeReset={changeReset}
                    onChange={(e: any) => {
                      setProjectName(e.target.value);
                      const index = projectsData
                        ?.map((item: any) => item)
                        .indexOf(e.target.value);
                      setProjectId(
                        allProjectData && allProjectData[index]?._id
                      );
                    }}
                    borderColor={"primary"}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} className="inventory_table_container">
          {discardedData?.length > 0 && <TableHeading
            title={tableTitle.discardedInventory}
            tab="discarded inventory"
            handleFilterDate={handleFilterDate}
            setValue={setfilterDate}
            value={filterDate}
            placeHolder={"Search"}
            searchValue={search}
            setSearchValue={filterData}
            handleDownload={handleDownload}
            resetSearch={resetSearch}
            resetToAll={() => {
              resetSearch();
              setfilterDate({ from: "", to: "" });
            }}
          />}
          {false ? (
            <Loader
              color="#5f67e0"
              loading={loading}
              size={20}
              height="80vh"
              style={{ width: "inherit" }}
            />
          ) : projectName === "" ? (
            <SelectOptionMsg text="Please select the project to get Discarded Inventory." />
          ) : (
            <DiscardedAndRepairInventoryTableComponent
              tab={"Discarded Inventory"}
              heading={discardedInventory}
              data={
                discardedData && discardedData.length > 0 ? discardedData : []
              }
              rows = {rows}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default DiscardedInventory;
